/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsFeaturedCollection = {
    init: function ($section) {

      // Add settings from schema to current object
      Shopify.theme.jsFeaturedCollection = $.extend(this, Shopify.theme.getSectionData($section));

      let $sliderEl = $section.find('[data-slider]');

      if (this.collection_style == 'slider') {
        this.createSlider($sliderEl);
      }
    },
    createSlider: function ($sliderEl) {

      const slideData = {
        products_per_slide: this.products_per,
        products_available: this.products_available,
        products_limit: this.products_limit,
      }

      const slider = $sliderEl.flickity({
         wrapAround: false,
        contain: true,
        cellAlign: 'left',
        freescroll:true,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        watchCSS: false,
        groupCells: false
        
     
        
      });
      slider.on('settle.flickity', function () {
        slider.flickity('resize');
      });

    },
    
    unload: function ($section) {
      let $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
    }
    
  }


  /******/
})()
  ;
$(document).ready(function(){
var flkty = new Flickity('section .featured-collection');
  
var progressBar = document.querySelector('.progress-bar')

flkty.on( 'scroll', function( progress ) {
  progress = Math.max( 0, Math.min( 1, progress ) );
  progressBar.style.width = progress * 100 + '%';
});
});
